/* jshint ignore:start */
var lang = (navigator.languages) ? navigator.languages[0] : (navigator.language || navigator.userLanguage);

module.exports = lang;
/* jshint ignore:end */
